import { render, staticRenderFns } from "./suporte-diagnostico-usuario.vue?vue&type=template&id=07e07aa2"
import script from "./suporte-diagnostico-usuario.vue?vue&type=script&lang=ts"
export * from "./suporte-diagnostico-usuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports